export default "__VITE_ASSET__bef2447d__"